import type { ContentRefReusableContent } from '@gitbook/api-client';
import { validateContentReference } from '@gitbook/app-content-refs';
import { Block, Schema } from '@gitbook/slate';

import {
    BLOCK_IF,
    BLOCK_REUSABLE_CONTENT,
    BLOCK_STEPPER_STEP,
    BLOCK_TABS_ITEM,
    FRAGMENT_EXPANDABLE_BODY,
} from '../types';

const validateReusableContentRef = validateContentReference(['reusable-content']);

/**
 * Schema to validate a "reusable-content" block.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_REUSABLE_CONTENT]: {
            isVoid: true,
            parent: {
                objects: ['document', 'fragment', 'block'],
                types: [
                    undefined,
                    BLOCK_STEPPER_STEP,
                    BLOCK_TABS_ITEM,
                    FRAGMENT_EXPANDABLE_BODY,
                    BLOCK_IF,
                ],
            },
            data: {
                ref: validateReusableContentRef,
            },
        },
    },
});

/**
 * Utility to create a "reusable-content" block.
 */
export function createReusableContentBlock(ref: ContentRefReusableContent): Block {
    return Block.createVoid({
        type: BLOCK_REUSABLE_CONTENT,
        data: {
            ref,
        },
    });
}
